module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 1_right_Light Blue.0833c2c6.svg";